import { BrandMark } from './BrandMark';

// Expanded sidebar: icon + "RAFAY / Control Tower" text lockup. See
// BrandMark.tsx for why this no longer renders the raw wordmark PNG (its
// white "TOWER" text and transparent ring interior were authored for a
// dark page background, not this app's new light one).
export const LogoFull = () => <BrandMark size={40} withText light />;
